import { createSlice } from "@reduxjs/toolkit";
import { IChat } from "types/IChat";
import { IAttachment } from "types/IAttachment";
import { apiCallBegan } from "../api";

const urlPrefix = "/api/v2/chatapp/user-chat";

interface IChats {
  chats: IChat | {};
  attachments: IAttachment;
  chatSliderConfig: {
    isOpen: boolean;
    messageId: string;
    messageType: string;
    imageUrls: string[];
  };
}

const initailState: IChats = {
  chats: {},
  attachments: { images: [] },
  chatSliderConfig: {
    isOpen: false,
    messageId: "",
    messageType: "",
    imageUrls: []
  }
};

const slice = createSlice({
  name: "chats",
  initialState: initailState,
  reducers: {
    chatsReceived: (state, action) => {
      const chats: any = {};
      //const currentChats = {...state.chats}
      const newChats = action.payload.chats;

      //improve this
      const currentChats = JSON.parse(JSON.stringify(state.chats));

      // console.log('currentChats', currentChats)
      // console.log('newChats', newChats)

      Object.keys(currentChats).forEach((k: string) => {
        chats[k] = currentChats[k];
      });
      Object.keys(newChats).forEach((k: string) => {
        //chats[k] = (chats[k]) ?  [...chats[k],...newChats[k]] : [...newChats[k]]

        if (chats[k]) {
          let allChats = [...chats[k], ...newChats[k]];
          // let temp = [];
          let dict: any = {};

          // for (let i = 0; i < allChats.length; i++) {
          //   const id = allChats[i].messageId.toString();

          //   if (!dict[id]) {
          //     temp.push(allChats[i]);
          //     dict[id] = true;
          //   }
          // }
          let temp = newChats[k].concat(
            chats[k].filter(
              (s: { messageId: any }) =>
                !newChats[k].find(
                  (t: { messageId: any }) => t.messageId == s.messageId
                )
            )
          );
          allChats = temp;

          allChats.sort((a: IChat, b: IChat) => {
            let ts1: Date = new Date(a["timeStamp"].toString());
            let ts2: Date = new Date(b["timeStamp"].toString());

            if (ts1 > ts2) {
              return -1;
            } else {
              return 1;
            }
          });

          chats[k] = allChats;
        } else {
          chats[k] = [...newChats[k]];
        }
      });
      state = {
        chats: chats,
        attachments:
          {
            images: state.attachments.images.concat(
              action.payload.attachments.images
            )
          } || [],
        chatSliderConfig: state.chatSliderConfig
      };
      return state;
    },
    messageMarkedRead: (state, action) => {
      // console.log("message was marked as read");
    },
    updateChatDeliveryStatus: (state, action) => {
      //const currentChats = JSON.parse(JSON.stringify(state.chats));
      const currentChats = getCurrentChatsFromState(state);
      // console.log('currentChats', currentChats);

      const keys = Object.keys(currentChats);
      let isFound = false;

      for (let i = 0; i < keys.length; i++) {
        const group = currentChats[keys[i]];

        for (let i = 0; i < group.length; i++) {
          if (group[i].messageId === action.payload.messageId) {
            group[i].deliveryStatus = action.payload.deliveryStatus;
            isFound = true;
            break;
          }
        }

        if (isFound) {
          break;
        }
      }

      state = {
        chats: currentChats,
        attachments: state.attachments,
        chatSliderConfig: state.chatSliderConfig
      };
      return state;
    },
    updateImageSlider: (state, action) => {
      state.chatSliderConfig = {
        ...state.chatSliderConfig,
        ...action.payload
      };
    }
  }
});

const getCurrentChatsFromState = (state: IChats) => {
  let a = { ...state.chats };
  let b = Object.keys(a).reduce((p: any, c: any) => {
    p[c] = [...a[c]].map((e) => {
      let k: any = { ...e };
      k.deliveryStatus = [...k.deliveryStatus];
      k.readBy = [...k.readBy].map((l) => {
        return { ...l };
      });
      return k;
    });
    return p;
  }, {});

  return b;
};

export const {
  chatsReceived,
  messageMarkedRead,
  updateChatDeliveryStatus,
  updateImageSlider
} = slice.actions;

//Action Creators
export const loadChats = (payload: any) => {
  let url: string = `${urlPrefix}/get-chats?chatId=${payload.chatId}&formatData=true&limit=20`;
  url = payload.timeStamp ? `${url}&timeStamp=${payload.timeStamp}` : url;

  return apiCallBegan({
    url: url,
    method: "GET",
    headers: {
      "Cache-Control": "no-cache"
    },
    onSuccess: chatsReceived.type,
    resolve: payload.resolve,
    reject: payload.reject
  });
};

export const updateChatReadStatus = (payload: any) => {
  return apiCallBegan({
    url: `${urlPrefix}/update-read-status-new`,
    method: "POST",
    onSuccess: messageMarkedRead.type,
    data: payload
  });
};

export default slice.reducer;
